
import React from 'react';


import {
    Slide,
    TextField,
    Grid,
    FormControl,
    InputLabel,
    FormHelperText,
    Input,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Button,
    Paper
} from "@material-ui/core";

import { Select, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import '../style.css';
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    input: {
        display: 'none',
    },
}));

const DirectAdmitRequest = () => {
    const classes = useStyles();
    const [facility, setFacility] = React.useState('');
    const handleFacilityChange = (event) => {
        setFacility(event.target.value);
    };
    return (
        <Slide in timeout={1000} direction="left">
            <div className="maincontent" style={{ padding: 24 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <FormControl>
                            <InputLabel htmlFor="name-input">First Name</InputLabel>
                            <Input
                                id="name-input"
                                aria-describedby="my-helper-text"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl>
                            <InputLabel htmlFor="my-input">Last Name</InputLabel>
                            <Input
                                id="my-input"
                                aria-describedby="my-helper-text"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl>
                            <InputLabel htmlFor="dob">Date of Birth</InputLabel>
                            <Input
                                id="dob"
                                aria-describedby="dob"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl>
                            <InputLabel htmlFor="email">Email Address</InputLabel>
                            <Input
                                id="email"
                                disabled={true}
                                aria-describedby="email-helper-text"
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl>
                            <InputLabel htmlFor="phone-number">Phone Number</InputLabel>
                            <Input
                                id="phone-number"
                                aria-describedby="Phone number"
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl>
                            <InputLabel htmlFor="demo-mutiple-chip-label">Facility</InputLabel>
                            <Select
                                labelId="demo-mutiple-chip-label"
                                id="demo-mutiple-chip"
                                value={facility}
                                onChange={handleFacilityChange}
                            >
                                <MenuItem value="1">St. Joseph's</MenuItem>
                                <MenuItem value="2">Memorial</MenuItem>
                                <MenuItem value="3">Sacred Heart</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl>
                            
                            <TextField variant="filled" label='Comments' multiline minRows={4} size='medium' aria-rowcount={4}/>

                            
 
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl>
                            <input
                                accept=""
                                className={classes.input}
                                id="contained-button-file"
                                multiple
                                type="file"
                            />
                            <label htmlFor="contained-button-file">
                                <Button variant="outlined" component="span">
                                    Upload Document
                                </Button>
                            </label>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>

                        <Button variant="contained" className="btn-primary" size="large" color="primary" disableElevation title="Save">
                            Save
                        </Button>

                    </Grid>
                </Grid>
            </div>
        </Slide>
    );
}

export default DirectAdmitRequest;